import { Component, Input, OnInit } from '@angular/core';
import { PaginationSettings } from '../../models/paginationsettings';
import { CallListService } from '../../services/call-list.service';
import { ActivatedRoute, Router } from '@angular/router';
import { VisitorService } from '../../services/visitor.service';
import { OperatorStatsCsvType } from '../../models/OperarorStatsCsvEnum';

@Component({
  selector: 'app-lista-poziva-operateri-report',
  templateUrl: './lista-poziva-operateri-report.component.html',
  styleUrls: ['./lista-poziva-operateri-report.component.scss'],
})
export class ListaPozivaOperateriReportComponent implements OnInit {

@Input() reportQuery = false;

calls$ = this.callService.calls$;

  operatorExtension: string = '';
  phoneQuery: string = '';
  status: number | null = null;
  dateFrom: string = '';
  dateTo: string = '';
  operators: any[] = [];


  pageSize = 2147483647;
  paginationSettings: PaginationSettings = {
    totalItems: 0,
    currentPage: 1,
    itemsPerPage: 20
  };
  FHour: number = null;
  FMinutes: number = null;
  FSeconds: number = null;

  THour: number = null;
  TMinutes: number = null;
  TSeconds: number = null;


  durationFromHours = null;
  durationFromMinutes = null;
  durationFromSeconds = null;
  durationToHours = null;
  durationToMinutes = null;
  durationToSeconds = null;
  durationFromQuery: string = ''
  durationToQuery: string = ''
  OperatorExtensionsList = []
  phoneCallStatusQuery: string = ''
  phoneCallStatus: string = ''
  StatusList: number[] = [];
  PhoneCallStatusList: number[] = [];

showCols: {
  callsCount: { [key: number]: boolean },
  callsDuration: { [key: number]: boolean },
  callsMinMaxAvg: { [key: number]: boolean },
} = {
  callsCount: {},
  callsDuration: {},
  callsMinMaxAvg:{}
};
operatorStats: any[] = [];
loading = false;
  constructor(
    private callService: CallListService,
    private route: ActivatedRoute,
    private router: Router,
    private visitorService: VisitorService
  ) { }

  ngOnInit(): void {

    if (this.route.snapshot.data?.reportQuery === true) {
      this.reportQuery = true;
    }

   this.callService.callPagination$
    .subscribe(pag => {
      if (!pag) return;
 this.paginationSettings = {
       totalItems: pag.totalItems,
  currentPage: this.paginationSettings.currentPage, 
  itemsPerPage: pag.itemsPerPage

      };
 
    });
  
  
  
    this.getOperatorsArray()

    this.StatusList = null;
    this.PhoneCallStatusList = null  
 
  for (let i = 0; i <= 18; i++) {
    this.showCols.callsCount[i] = true;
  }

  for (let i = 0; i <= 18; i++) {
    this.showCols.callsDuration[i] = true;
  }

  for (let i = 0; i <= 26; i++) {
    this.showCols.callsMinMaxAvg[i] = true;
  }


  }


onChange(e: any, table: 'callsCount' | 'callsDuration' | 'callsMinMaxAvg', index: number) {
  this.showCols[table][index] = e.target.checked;
}
columns1Open=false;
columns2Open=false;
columns3Open=false;

resetColumns(table: 'callsCount' | 'callsDuration' | 'callsMinMaxAvg') {
  Object.keys(this.showCols[table]).forEach(
    key => this.showCols[table][+key] = true
  );
}
decheckColumns(table: 'callsCount' | 'callsDuration' | 'callsMinMaxAvg') {
  Object.keys(this.showCols[table]).forEach(
    key => this.showCols[table][+key] = false
  );
}

  loadSearchResult() {
    this.loading = true;
    this.callService.getAllCallsSearch({
      pageNumber: this.paginationSettings.currentPage,
      pageSize: this.paginationSettings.itemsPerPage,
      currentPage: this.paginationSettings.currentPage,
      itemsPerPage: this.paginationSettings.itemsPerPage,
      operatorExtension: null,
      phoneQuery: this.phoneQuery || null,
      StatusList: this.StatusList,
      dateFrom: this.dateFrom || null,
      dateTo: this.dateTo || null,
      durationFromQuery: this.durationFromQuery || null,
      durationToQuery: this.durationToQuery || null,

      PhoneCallStatusList: this.PhoneCallStatusList,

      ReportQuery: this.reportQuery,

      OperatorsExtensionList: this.OperatorExtensionsList ?? []
    }).subscribe({
      next: (res) => {
        this.stats = res;
        this.loading = false;
        console.log("Operators Stats", this.stats)
      },
      error: (err) => {
        this.loading = false;
        console.error('Greška pri učitavanju statistike:', err);
      }
    });
 this.loadStats()
 this.loadStatsOperators()
 
 
  }


  resetFilters() {
    this.operatorExtension = '';
    this.phoneQuery = '';
    this.status = null;
    this.dateFrom = '';
    this.dateTo = '';
    this.durationFromQuery = '';
    this.durationToQuery = '';
    this.phoneCallStatusQuery = '';

    this.durationFromHours = null;
    this.durationFromMinutes = null;
    this.durationFromSeconds = null;
    this.durationToHours = null;
    this.durationToMinutes = null;
    this.durationToSeconds = null;
    this.loadSearchResult();
    this.loadStats()
    this.loadStatsOperators()
  }  

  statuses = [
    { id: 0, label: 'Zakazan', selected: false },
    { id: 1, label: 'Otkazan', selected: false },
    { id: 2, label: 'Raspituje se', selected: false },
    { id: 3, label: 'Razmisliće', selected: false },
    { id: 4, label: 'Pozvati ga', selected: false },
    { id: 5, label: 'Rezervisan', selected: false },
    { id: -1, label: 'Neobrađen', selected: false },
    { id: 6, label: 'Svi rođendani', selected: true },

  ];



  async goToVisitorCard(id?: number | string, callId?: number | string, phoneNum?: number | string) {
    await this.router.navigate(['admin/manage-visitors'], { skipLocationChange: true });
    console.log("visitor id:", id);
    console.log("call id:", callId);

    localStorage.setItem("callId", String(callId));

    let cleanPhone = String(phoneNum);
    if (cleanPhone.startsWith("+381")) {
      cleanPhone = cleanPhone.substring(4);
    }
    localStorage.setItem("phoneNum", cleanPhone);
    if (!id) return;

    const visitor = await this.visitorService.getVisitorByIdTyped(Number(id)).toPromise();
    console.log("visitor status:", visitor.visitorStatus);

    if (visitor.visitorStatus === 4) {

      await this.router.navigate(['admin/kartica-visitora']);
    } else {
      await this.router.navigate(['admin/kartica-visitora', id]);
    }
  }

  getLocalTimeFromServer(utcString: string): string {

    if (!utcString) return '';
    const date = new Date(utcString + 'Z');
    const years = String(date.getFullYear())
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const days = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${days}-${month}-${years} ${hours}:${minutes}:${seconds}`;
  }

  onFromHoursChange(event: any) {
    this.FHour = this.durationFromHours
    this.generateFromQuery(this.FHour, this.FMinutes, this.FSeconds)
  }

  onFromMinutesChange(event: any) {
    this.FMinutes = this.durationFromMinutes
    this.generateFromQuery(this.FHour, this.FMinutes, this.FSeconds)
  }

  onFromSecondsChange(event: any) {
    this.FSeconds = this.durationFromSeconds
    this.generateFromQuery(this.FHour, this.FMinutes, this.FSeconds)
  }

  onToHoursChange(event: any) {
    this.THour = this.durationToHours
    this.generateToQuery(this.THour, this.TMinutes, this.TSeconds)
  }

  onToMinutesChange(event: any) {
    this.TMinutes = this.durationToMinutes
    this.generateToQuery(this.THour, this.TMinutes, this.TSeconds)
  }

  onToSecondsChange(event: any) {
    this.TSeconds = this.durationToSeconds
    this.generateToQuery(this.THour, this.TMinutes, this.TSeconds)
  }

  generateFromQuery(FHour: number | null, FMinutes: number | null, FSeconds: number | null): void {
    const HH = (FHour ?? 0).toString().padStart(2, '0');
    const MM = (FMinutes ?? 0).toString().padStart(2, '0');
    const SS = (FSeconds ?? 0).toString().padStart(2, '0');
    this.durationFromQuery = `${HH}:${MM}:${SS}`;
    console.log("this.durationFromQuary", this.durationFromQuery)
  }

  generateToQuery(THour: number | null, TMinutes: number | null, TSeconds: number | null): void {
    const HH = (THour ?? 0).toString().padStart(2, '0');
    const MM = (TMinutes ?? 0).toString().padStart(2, '0');
    const SS = (TSeconds ?? 0).toString().padStart(2, '0');
    this.durationToQuery = `${HH}:${MM}:${SS}`;
    console.log("this.durationToQuary", this.durationToQuery)

  }

  phoneCallStatuses = [
    { id: 0, label: 'Zakazivanje rodjendan', selected: false },
    { id: 1, label: 'Ostali telefonki pozivi', selected: false },
    { id: 2, label: 'Propušteni pozivi', selected: false },

  ];

  statsGlobal: any = {
    totalCount: 0,
    filteredCount: 0,
    percentFiltered: 0,
    totalDurationAll: 0,
    totalDurationFiltered: 0,
    minDuration: 0,
    maxDuration: 0,
    avgDuration: 0,
    percentFilteredCalls: 0
  };

  stats = [{
    totalCount: 0,
    filteredCount: 0,
    percentFiltered: 0,
    totalDurationAll: 0,
    totalDurationFiltered: 0,
    minDuration: 0,
    maxDuration: 0,
    avgDuration: 0,
    percentFilteredCalls: 0
  }];

  loadStats() {
    console.log('📊 loadStats() pozvan!');
    this.callService.getFilteredCallStats({
      operatorExtension: this.operatorExtension || null,
      phoneQuery: this.phoneQuery || null,
      dateFrom: this.dateFrom || null,
      dateTo: this.dateTo || null,
      durationFromQuery: this.durationFromQuery || null,
      durationToQuery: this.durationToQuery || null,
      PhoneCallStatusList: this.PhoneCallStatusList,
      StatusList: this.StatusList,
      ReportQuery: this.reportQuery,
      OperatorsExtensionList: this.OperatorExtensionsList || []
    }).subscribe({
      next: (res) => {
        this.statsGlobal = res;
      },
      error: (err) => {
        console.error('Greška pri učitavanju statistike:', err);
      }
    });
  }


  changePage(pageNumber: number) {
    this.paginationSettings.currentPage = pageNumber;
    this.loadSearchResult();
  }

  loadStatsOperators() {

    console.log('📊 loadStats() pozvan!');
    this.callService.getFilteredCallStatsOperators({
      operatorExtension: this.operatorExtension || null,
      phoneQuery: this.phoneQuery || null,
      status: this.status != null ? this.status : null,
      dateFrom: this.dateFrom || null,
      dateTo: this.dateTo || null,
      durationFromQuery: this.durationFromQuery || null,
      durationToQuery: this.durationToQuery || null,
      phoneCallStatusQuery: this.phoneCallStatusQuery || null,
      PhoneCallStatusList: this.PhoneCallStatusList,
      OperatorsExtensionList: this.OperatorExtensionsList || [],
      StatusList: this.StatusList,
      ReportQuery: this.reportQuery,
    }).subscribe({
      next: (res) => {
       this.operatorStats = res;
        console.log("Operators Stats Lista statistike po operaterima", this.operatorStats )
      },
      error: (err) => {
        console.error('Greška pri učitavanju statistike:', err);
      }
    });
  }

 
 
 
  getOperatorsArray() {
    this.callService.getOperators().subscribe({
      next: (res) => {
        this.operators = res || [];
        console.log(this.operators, "this operators")
        this.operators.forEach(op => op.selected = true);
        this.OperatorExtensionsList = this.operators.map(op => op.operaterId);
        console.log(this.OperatorExtensionsList, "this.operatorExtensionsList")
         this.reload()
       
      },
      error: (err) => console.error('Greška pri učitavanju operatera:', err),

    });

  }


operatorsOpen = false;

onOperatorToggle(changedOperator: any) {
  this.OperatorExtensionsList = this.operators
    .filter(o => o.selected)
    .map(o => o.operaterId);

  this.reload();
}

statusOpen=false;
 onStatusToggle(changedStatus: any) {

 
  if (changedStatus.id === 6 && changedStatus.selected) {
    this.statuses.forEach(s => s.selected = s.id === 6);
    this.StatusList = null;
    this.reload();
    return;
  }

  
  if (changedStatus.id === -1 && changedStatus.selected) {
    this.statuses.forEach(s => s.selected = s.id === -1);
    this.StatusList = [-1];
    this.reload();
    return;
  }

  
  if (changedStatus.selected) {
   
    this.statuses.find(s => s.id === 6)!.selected = false;
    this.statuses.find(s => s.id === -1)!.selected = false;
  }

  this.StatusList = this.statuses
    .filter(s => s.selected && s.id !== 6 && s.id !== -1)
    .map(s => s.id);

  if (this.StatusList.length === 0) {
    this.StatusList = null;
  }

  this.reload();
  

}
 


statusPhoneOpen=false
  onPhoneStatusToggle(changedPhoneCallStatus: any) {
    this.PhoneCallStatusList = this.phoneCallStatuses
      .filter(s => s.selected)
      .map(s => s.id);


    if (this.PhoneCallStatusList.length === 0) {
      this.PhoneCallStatusList = null;
    }

    console.log(this.PhoneCallStatusList, 'StatusList');
    this.reload();
  }

   private reload() {
    this.paginationSettings.currentPage = 1;
    this.loadSearchResult();
    this.loadStats();
    this.loadStatsOperators();
  }


operatorStatsNumberOfCalls = [
    { id: 0, label: 'Ukupno broj poziva', selected: true },
    { id: 1, label: 'Zakazivanje', selected: true },
    { id: 2, label: 'Udeo zakazivanje (%)', selected: true },
    { id: 3, label: 'Ostali pozivi', selected: true },
    { id: 4, label: 'Udeo ostalih poziva (%)', selected: true },
    { id: 5, label: 'Zakazani', selected: true },
    { id: 6, label: 'Udeo Zakazani (%)', selected: true },
    { id: 7, label: 'Otkazani', selected: true },
    { id: 8, label: 'Udeo Otkazanih (%)', selected: true },
    { id: 9, label: 'Raspituje se', selected: true },
    { id: 10, label: 'Udeo Raspituje se (%)', selected: true },
    { id: 11, label: 'Razmisliće', selected: true },
    { id: 12, label: 'Udeo Razmisliće (%)', selected: true },
    { id: 13, label: 'Pozvati ga', selected: true },
    { id: 14, label: 'Udeo Pozvati ga (%)', selected: true },
    { id: 15, label: 'Rezervisan', selected: true },
    { id: 16, label: 'Udeo Rezervisan (%)', selected: true },

    { id: 17, label: 'Nezakazani', selected: true },
    { id: 18, label: 'Udeo Nezakazani (%)', selected: true },

  ];

operatorStatsDuration = [
    { id: 0, label: 'Ukupno trajanje poziva', selected: true },
    { id: 1, label: 'Zakazivanje', selected: true },
    { id: 2, label: 'Udeo zakazivanje (%)', selected: true },
    { id: 3, label: 'Ostali pozivi', selected: true },
    { id: 4, label: 'Udeo ostalih poziva (%)', selected: true },
    { id: 5, label: 'Zakazani', selected: true },
    { id: 6, label: 'Udeo Zakazani (%)', selected: true },
    { id: 7, label: 'Otkazani', selected: true },
    { id: 8, label: 'Udeo Otkazanih (%)', selected: true },
    { id: 9, label: 'Raspituje se', selected: true },
    { id: 10, label: 'Udeo Raspituje se (%)', selected: true },
    { id: 11, label: 'Razmisliće', selected: true },
    { id: 12, label: 'Udeo Razmisliće (%)', selected: true },
    { id: 13, label: 'Pozvati ga', selected: true },
    { id: 14, label: 'Udeo Pozvati ga (%)', selected: true },
     { id: 15, label: 'Rezervisan', selected: true },
    { id: 16, label: 'Udeo Rezervisan (%)', selected: true },
    { id: 17, label: 'Nezakazani', selected: true },
    { id: 18, label: 'Udeo Nezakazani (%)', selected: true },


  ];

operatorStatsMinMaxAvgDuration = [
    { id: 0, label: 'Zakazivanje min', selected: true },
    { id: 1, label: 'Zakazivanje max', selected: true },
    { id: 2, label: 'Zakazivanje prosek', selected: true },
    { id: 3, label: 'Ostali pozivi min	', selected: true },
    { id: 4, label: 'Ostali pozivi max', selected: true },
    { id: 5, label: 'Ostali pozivi prosek', selected: true },
    { id: 6, label: 'Zakazani min', selected: true },
    { id: 7, label: 'Zakazani max', selected: true },
    { id: 8, label: 'Zakazani prosek', selected: true },
    { id: 9, label: 'Otkazani min', selected: true },
    { id: 10, label: 'Otkazani max', selected: true },
    { id: 11, label: 'Otkazani prosek', selected: true },
    { id: 12, label: 'Raspituje se min', selected: true },
    { id: 13, label: 'Raspituje se max', selected: true },
    { id: 14, label: 'Raspituje se prosek', selected: true },
    { id: 15, label: 'Razmisliće min', selected: true },
    { id: 16, label: 'Razmisliće max', selected: true },
    { id: 17, label: 'Razmisliće prosek', selected: true },
    { id: 18, label: 'Pozvati ga min', selected: true },
    { id: 19, label: 'Pozvati ga max', selected: true },
    { id: 20, label: 'Pozvati ga prosek', selected: true },

    { id: 21, label: 'Rezervisan min', selected: true },
    { id: 22, label: 'Rezervisan max', selected: true },
    { id: 23, label: 'Rezervisan prosek', selected: true },

    { id: 24, label: 'Nezakazani min', selected: true },
    { id: 25, label: 'Nezakazani max', selected: true },
    { id: 26, label: 'Nezakazani prosek', selected: true },
  ];

exportCounts() {
   this.exportCsv(OperatorStatsCsvType.Counts);
}

exportDuration() {
  this.exportCsv(OperatorStatsCsvType.Duration);
}
exportMinMaxAvg(){

   this.exportCsv(OperatorStatsCsvType.MinMaxAvg);
}
exportCsv(type: OperatorStatsCsvType) {
  this.callService
    .exportStatsOperatorsCSV(this.getFilters(), type)
    .subscribe(blob => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `operators_${type}.csv`;
      a.click();
      URL.revokeObjectURL(url);
    });
}
private getFilters() {
  return {
    pageSize: this.pageSize,
    operatorExtension: this.operatorExtension || null,
    phoneQuery: this.phoneQuery || null,
    dateFrom: this.dateFrom || null,
    dateTo: this.dateTo || null,
    durationFromQuery: this.durationFromQuery || null,
    durationToQuery: this.durationToQuery || null,
    PhoneCallStatusList: this.PhoneCallStatusList,
    StatusList: this.StatusList,
    ReportQuery: this.reportQuery,
    OperatorsExtensionList: this.OperatorExtensionsList || []
  };
}
exportCallListCsv() {
  this.callService
    .exportListCSV(this.getFilters())
     .subscribe(csvText => {
      this.blobToFile(csvText, 'text/csv', 'calls_export.csv');
     });

}


  blobToFile(data: any, type: string, fileName: string) {
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.style.display = 'none';
    const blob = new Blob([data], { type });
    const url = window.URL.createObjectURL(blob);
    a.href = url; a.download = fileName; a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }


}
